module.exports = __webpack_public_path__ + "img/projecttop.840dcbb9.jpg";